import { Injectable } from '@angular/core';
import { IVisitType, VisitType } from '../models/visit-type.model';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';
import { IPresignResponse } from '../models/presign-response.model';
import { AwsService } from './aws.service';

@Injectable({
  providedIn: 'root'
})
export class VisitTypeService {

  public loading: boolean = false;
  public visitTypes: VisitType[] = [];

  constructor(
    public authService: AuthService,
    public awsService: AwsService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) {

    this.getAll();

  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
   async create(
    visitType: IVisitType,
    file?: File
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/visit-types`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Registrando tipo de visita';

    try {

      const token = await this.authService.getToken();

      const body: any = { ...visitType };
      if (file) {
        body.contentType = file.type;
      }

      const response = await new Promise<ServerResponse<{ presignFile: IPresignResponse }>>(
        (resolve, reject) => {
          this.http.post<IServerResponse<{ presignFile: IPresignResponse }>>(
            urlApi,
            JSON.stringify(body),
            {
              headers: {
                "content-type": "application/json",
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ presignFile: IPresignResponse }>
              ) => resolve(
                new ServerResponse<{ presignFile: IPresignResponse }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 201) {
        flag = true;

        if (file && response.data?.presignFile?.uploadUrl) {
          await this.awsService.uploadFile(
            response.data.presignFile.uploadUrl,
            file,
            file.type,
            file.name
          );
        }

        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.getAll();
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    return flag;

  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(
    visitType: VisitType
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/visit-types/${visitType.visitTypeId}`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Eliminando tipo de visita';

    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.delete<IServerResponse>(
            urlApi,
            {
              headers: {
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        flag = true;

        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.getAll();
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';
  
    return flag;

  }

  /*
   ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  /**
   * FUNCTION getAll
   */
  async getAll() {

    this.loading = true;

    const urlApi = `${environment.urlApi}/visit-types`;

    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse<{ visitTypes: IVisitType[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ visitTypes: IVisitType[] }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ visitTypes: IVisitType[] }>
              ) => resolve(
                new ServerResponse<{ visitTypes: IVisitType[] }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        this.visitTypes = response.data!.visitTypes.map(
          visitType => new VisitType(visitType)
        );
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);
      
    }

    this.loading = false;

  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update(
    visitType: any,
    file?: File
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/visit-types/${visitType.visitTypeId}`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Actualizando tipo de visita';

    try {

      const token = await this.authService.getToken();

      const body: any = { ...visitType };
      if (file) {
        body.contentType = file.type;
      }

      const response = await new Promise<ServerResponse<{ presignFile: IPresignResponse }>>(
        (resolve, reject) => {
          this.http.put<IServerResponse<{ presignFile: IPresignResponse }>>(
            urlApi,
            JSON.stringify(body),
            {
              headers: {
                "content-type": "application/json",
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ presignFile: IPresignResponse }>
              ) => resolve(
                new ServerResponse<{ presignFile: IPresignResponse }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        flag = true;

        if (file && response.data?.presignFile?.uploadUrl) {
          await this.awsService.uploadFile(
            response.data.presignFile.uploadUrl,
            file,
            file.type,
            file.name
          );
        }

        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.getAll();
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    return flag;

  }
}
